import React, { useState, useEffect } from 'react';
import { Grid, Paper } from '@mui/material';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import axios from "axios";
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';

const QuotDiscountTable = ({ Id }) => {

const baseUrl = process.env.REACT_APP_BASE_URL;

const [quotationlist,setQuotationList] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);
const [pageRange, setPageRange] = useState([0, 10]);
const [searchTerm, setSearchTerm] = useState('');


// ================= API CALL =================
useEffect(() => {
 if(Id){
   fetchData(Id)
 }
}, [Id])

const fetchData = async (Id) =>{
 try{
   const res = await axios.get(`${baseUrl}?apicall=getMultiQtDiscountlist&Id=${Id}`);
   console.log("API DATA =>",res.data);
   setQuotationList(res?.data?.data || []);
 }
 catch(err){
   console.log("API ERROR =>",err);
 }
}

// ================= VIEW BUTTON =================
const handleView = (mqtId,mil_pct,scr_pct,quot_no,mqtDisNo,dt) =>{
 window.open(
  `/qtDiscountPerView/${mqtId}/${mil_pct}/${scr_pct}/${quot_no}/${mqtDisNo}/${dt}`,
  '_blank',
  'width=1000,height=600,scrollbars=yes,resizable=yes'
 );
}

// ================= SAFE FILTER =================
const filteredData = quotationlist.filter(item =>
  (item?.mqtDisNo || '').toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
  (item?.quot_no || '').toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
  (item?.dt || '').toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
  (item?.mil_pct || '').toString().includes(searchTerm) ||
  (item?.scr_pct || '').toString().includes(searchTerm)
);

const totalPages = Math.ceil(filteredData.length / itemsPerPage);

const displayedData = filteredData.slice(
 (currentPage - 1) * itemsPerPage,
 currentPage * itemsPerPage
);

const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

const handleSearchChange = (event) => {
 setSearchTerm(event.target.value);
 setCurrentPage(1);
};

const handleItemsPerPageChange = (event) => {
 setItemsPerPage(Number(event.target.value));
 setCurrentPage(1);
};

const handlePageChange = (page) => {
 setCurrentPage(page);
};

const handleNextPageRange = () => {
 setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
};

const handlePreviousPageRange = () => {
 setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
};


// ================= UI =================
return (
<div style={{ margin: '1% 0.5%' }}>
<h2>Multiple Quotation Discount Register</h2>

<Grid container spacing={2}>
<Grid item xs={12}>
<Paper style={{ padding: '3vh' }}>

<SearchTable
 handleItemsPerPageChange={handleItemsPerPageChange}
 searchTerm={searchTerm}
 handleSearchChange={handleSearchChange}
 totalItems={filteredData?.length}
/>

<TableContainer style={{ marginTop: '2%' }}>
<Table>

<TableHeader
 headCells={[
  { id: 'srno', label: 'SrNo' },
  { id: 'dt', label: 'Date' },
  { id: 'mqtDisNo', label: 'Multiple Quotation No' },
  { id: 'quot_no', label: 'Quotation No' },
  { id: 'mil_pct', label: 'MIL %' },
  { id: 'scr_pct', label: 'SCR %' },
  { id: 'view', label: 'View' },
 ]}
 rowCount={quotationlist.length}
/>

<TableBody>
{displayedData.map((row,index)=>(
<TableRow key={index}>
<TableCell sx={{p:1,border:'1px solid #000'}} align="center">{index+1}</TableCell>
<TableCell sx={{p:1,border:'1px solid #000'}} align="center">{row.dt}</TableCell>
<TableCell sx={{p:1,border:'1px solid #000'}} align="center">{row.mqtDisNo}</TableCell>
<TableCell sx={{p:1,border:'1px solid #000'}} align="center">{row.quot_no}</TableCell>
<TableCell sx={{p:1,border:'1px solid #000'}} align="center">{row.mil_pct}</TableCell>
<TableCell sx={{p:1,border:'1px solid #000'}} align="center">{row.scr_pct}</TableCell>

<TableCell align="center" sx={{p:1,border:'1px solid #000'}}>
<IconButton
 onClick={()=>handleView(row.mqtId,row.mil_pct,row.scr_pct,row.quot_no,row.mqtDisNo,row.dt)}
 color="primary"
>
<VisibilityIcon/>
</IconButton>
</TableCell>

</TableRow>
))}
</TableBody>

</Table>
</TableContainer>

<Pagination
 currentPage={currentPage}
 handlePageChange={handlePageChange}
 handlePreviousPageRange={handlePreviousPageRange}
 visiblePageNumbers={visiblePageNumbers}
 pageNumber={pageNumbers}
 pageRange={pageRange}
 totalPages={totalPages}
 handleNextPageRange={handleNextPageRange}
/>

</Paper>
</Grid>
</Grid>
</div>
);
}

export default QuotDiscountTable;